import React from "react";
import { Target, Sparkles, Clock, Flag } from "lucide-react";
import { goalPct, milestoneMsg, deadlineInfo, MILESTONES, money } from "@/lib/tipgoal";

export default function TipGoalBar({ goalCents, progressCents = 0, label, deadline, compact = false }) {
  if (!goalCents) return null;
  const pct = goalPct(progressCents, goalCents);
  const reached = progressCents >= goalCents;
  const dl = deadlineInfo(deadline);
  const ended = dl?.ended;
  const shout = milestoneMsg(pct);

  return (
    <div className={`nu-card p-4 sm:p-5 ${compact ? "" : "mt-4"}`} data-testid="tip-goal-bar">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Target className="w-4 h-4 text-emerald-400 shrink-0" />
          <span className="text-sm font-semibold truncate">{label || "Tip Goal"}</span>
        </div>
        <span className="text-xs font-mono-nu text-zinc-400 shrink-0" data-testid="tip-goal-amount">
          {money(progressCents)} <span className="text-zinc-600">/ {money(goalCents)}</span>
        </span>
      </div>

      <div className="mt-3 relative h-2.5 rounded-full bg-white/5 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-700 ${reached ? "bg-amber-400" : "bg-gradient-to-r from-emerald-500 to-emerald-400"}`}
          style={{ width: `${pct}%` }}
          data-testid="tip-goal-fill"
        />
        {MILESTONES.slice(0, 3).map((m) => (
          <span key={m} className="absolute top-0 bottom-0 w-px bg-black/50" style={{ left: `${m}%` }} />
        ))}
      </div>

      <div className="mt-2 flex items-center justify-between gap-2 flex-wrap">
        <p className="text-xs text-zinc-500 flex items-center gap-1" data-testid="tip-goal-shout">
          {ended ? (
            <><Flag className="w-3.5 h-3.5 text-zinc-500" /> Goal ended</>
          ) : reached ? (
            <><Sparkles className="w-3.5 h-3.5 text-amber-400" /> Goal smashed this month — thank you! 🎉</>
          ) : (
            <>{shout ? <><Sparkles className="w-3.5 h-3.5 text-emerald-400" /> {shout}</> : `${pct}% there this month`}</>
          )}
        </p>
        {dl && (
          <span className={`text-[11px] font-mono-nu flex items-center gap-1 ${ended ? "text-zinc-600" : dl.daysLeft <= 2 ? "text-amber-400" : "text-zinc-500"}`} data-testid="tip-goal-deadline">
            <Clock className="w-3 h-3" /> {dl.label}
          </span>
        )}
      </div>
    </div>
  );
}
